import { render, staticRenderFns } from "./CompanyManagement.vue?vue&type=template&id=45de332c&scoped=true"
import script from "./CompanyManagement.vue?vue&type=script&lang=js"
export * from "./CompanyManagement.vue?vue&type=script&lang=js"
import style0 from "./CompanyManagement.vue?vue&type=style&index=0&id=45de332c&prod&scoped=true&lang=css"
import style1 from "./CompanyManagement.vue?vue&type=style&index=1&id=45de332c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45de332c",
  null
  
)

export default component.exports